import React from "react";
import "./editModal.css";
import "./editContactModal.css";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";
import OtpTimer from "otp-timer";
import CloseIcon from "@mui/icons-material/Close";
import EditIcon from "../../../assets/icon/Edit.svg";
import { countryCodes, userDetails, updateContactSendOtp, updateContactVerifyOtp } from "../../../services/MainApiDetails";
import { User } from "../../../actions";
import { useDispatch } from "react-redux";
import { ERROR, SUCCESS } from "../../../utilities/colors";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

// field: "phone" | "email"
const EditContactModal = ({ field, currentValue, currentDialCode = "+91" }) => {
  const dispatch = useDispatch();

  const [open, setOpen] = React.useState(false);
  const [step, setStep] = React.useState(1);
  const [value, setValue] = React.useState("");
  const [dialCode, setDialCode] = React.useState(currentDialCode);
  const [countryCodes_, setCountryCodes_] = React.useState([]);
  const [otp, setOtp] = React.useState("");
  const [error, setError] = React.useState("");
  const [successMsg, setSuccessMsg] = React.useState("");
  const [loading, setLoading] = React.useState(false);

  React.useEffect(() => {
    if (field === "phone") {
      countryCodes({}).then((res) => {
        if (res?.data?.status === 1) setCountryCodes_(res.data.result);
      });
    }
  }, [field]);

  React.useEffect(() => {
    if (open) {
      setValue(currentValue || "");
      setDialCode(currentDialCode || "+91");
      setOtp("");
      setError("");
      setSuccessMsg("");
      setStep(1);
      setLoading(false);
    }
  }, [open]);

  const buttonDisabled = React.useMemo(() => {
    if (field === "phone")
      return value?.trim() === (currentValue?.trim() ?? "") && dialCode === currentDialCode;
    return value?.trim() === (currentValue?.trim() ?? "");
  }, [field, value, dialCode, currentValue, currentDialCode]);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  function validateInput() {
    if (field === "phone") {
      const regex = /^(\+?[0-9]{2})?([0-9]{10})$/;
      if (!value || !regex.test(value) || value.length < 8 || value.length > 12) {
        setError("Enter a valid phone number");
        return false;
      }
    } else {
      const regex = /^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$/;
      if (!value || !regex.test(value)) {
        setError("Enter a valid email address");
        return false;
      }
    }
    return true;
  }

  function handleSendOtp() {
    setError("");
    if (!validateInput()) return;
    setLoading(true);
    const payload =
      field === "phone"
        ? { phone: value, country_code: dialCode.replace("+", "") }
        : { email: value.toLowerCase() };
    updateContactSendOtp(payload)
      .then((res) => {
        if (res?.data?.status === 1) {
          setStep(2);
        } else {
          setError(res?.data?.message || "Failed to send OTP");
        }
      })
      .finally(() => setLoading(false));
  }

  function handleResendOtp() {
    setError("");
    const payload =
      field === "phone"
        ? { phone: value, country_code: dialCode.replace("+", "") }
        : { email: value.toLowerCase() };
    updateContactSendOtp(payload);
  }

  function handleVerifyOtp() {
    setError("");
    if (!otp.trim()) {
      setError("Please enter the OTP");
      return;
    }
    setLoading(true);
    const payload =
      field === "phone"
        ? { phone: value, country_code: dialCode.replace("+", ""), otp: parseInt(otp.trim()) }
        : { email: value.toLowerCase(), otp: parseInt(otp.trim()) };
    updateContactVerifyOtp(payload)
      .then((res) => {
        if (res?.data?.status === 1) {
          setSuccessMsg("Updated successfully!");
          userDetails().then((detailsRes) => {
            if (detailsRes?.data?.status === 1) {
              dispatch(User(detailsRes.data.user_data));
            }
          });
          setTimeout(() => handleClose(), 1200);
        } else {
          setError(res?.data?.message || "Invalid OTP");
        }
      })
      .finally(() => setLoading(false));
  }

  const title = field === "phone" ? "Edit Phone Number" : "Edit Email";

  return (
    <div className="editNameModal">
      <div onClick={handleOpen} className="userInfo-edit">
        <img src={EditIcon} alt="" />
      </div>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-describedby="edit-contact-dialog"
      >
        <div className="editNameModal-wrapper editContactModal-wrapper">
          <div className="editNameModal-closeIcon">
            <CloseIcon className="closeIcon" onClick={handleClose} />
          </div>
          <div className="editNameModal-header">
            <h2>{title}</h2>
          </div>

          {step === 1 && (
            <>
              <div className="editNameModal-form-wrapper">
                <div className="editNameModal-input-wrapper">
                  {field === "phone" ? (
                    <div className="editNameModal-inputBox">
                      <span>{field === "phone" ? "Phone Number" : "Email"}</span>
                      <div className="editContactModal-phoneInput-container">
                        <select
                          value={dialCode}
                          onChange={(e) => setDialCode(e.target.value)}
                          className="editContactModal-dialCode-select"
                        >
                          {countryCodes_.map((item) => (
                            <option key={item._id} value={item.dial_code}>
                              {item.dial_code}
                            </option>
                          ))}
                        </select>
                        <input
                          type="number"
                          placeholder="Type here"
                          value={value}
                          onChange={(e) => { setValue(e.target.value); setError(""); }}
                        />
                      </div>
                      {error && <span style={{ color: ERROR }}>{error}</span>}
                    </div>
                  ) : (
                    <div className="editNameModal-inputBox">
                      <span>New Email</span>
                      <input
                        type="text"
                        placeholder="Type here"
                        value={value}
                        onChange={(e) => { setValue(e.target.value); setError(""); }}
                      />
                      {error && <span style={{ color: ERROR }}>{error}</span>}
                    </div>
                  )}
                </div>
              </div>
              <div className="editNameModal-button-wrapper">
                <Button
                  type="button"
                  disabled={loading || buttonDisabled}
                  className={loading || buttonDisabled ? "editNameModal-login-btn-disabled" : "editNameModal-login-btn"}
                  onClick={handleSendOtp}
                >
                  {loading ? "SENDING..." : "SEND OTP"}
                </Button>
              </div>
            </>
          )}

          {step === 2 && (
            <>
              <p className="editContactModal-sent-to">
                OTP sent to{" "}
                <strong>
                  {field === "phone" ? `${dialCode} ${value}` : value}
                </strong>
                <span
                  className="editContactModal-change-link"
                  onClick={() => { setStep(1); setOtp(""); setError(""); }}
                >
                  Change
                </span>
              </p>
              <div className="editNameModal-form-wrapper">
                <div className="editNameModal-input-wrapper">
                  <div className="editNameModal-inputBox">
                    <span>Enter OTP</span>
                    <input
                      type="text"
                      placeholder="Type here"
                      value={otp}
                      onChange={(e) => { setOtp(e.target.value); setError(""); }}
                    />
                    {error && <span style={{ color: ERROR }}>{error}</span>}
                    {successMsg && <span style={{ color: SUCCESS }}>{successMsg}</span>}
                  </div>
                </div>
              </div>
              <div className="editNameModal-button-wrapper">
                <Button
                  type="button"
                  disabled={loading || !!successMsg}
                  className={loading || successMsg ? "editNameModal-login-btn-disabled" : "editNameModal-login-btn"}
                  onClick={handleVerifyOtp}
                >
                  {loading ? "VERIFYING..." : "VERIFY OTP"}
                </Button>
              </div>
              <div className="editContactModal-resend-otp">
                <OtpTimer
                  minutes={1}
                  seconds={1}
                  text="Resend OTP in"
                  ButtonText="Resend OTP"
                  resend={handleResendOtp}
                />
              </div>
            </>
          )}
        </div>
      </Dialog>
    </div>
  );
};

export default EditContactModal;
